"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Stores = require("../../store/Application");
var ApplicationSelector = /** @class */ (function (_super) {
    __extends(ApplicationSelector, _super);
    function ApplicationSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            pageLoad: true
        };
        _this.onChangeApps = _this.onChangeApps.bind(_this);
        return _this;
    }
    ApplicationSelector.prototype.componentDidMount = function () {
        this.ensureDataFetched();
    };
    ApplicationSelector.prototype.ensureDataFetched = function () {
        this.props.requestFunction(this.state.pageLoad);
        this.state = {
            pageLoad: false
        };
    };
    ApplicationSelector.prototype.onChangeApps = function (e) {
        this.props.hookAppsId(e.target.value);
    };
    ApplicationSelector.prototype.render = function () {
        if ((this.props.isLoading && this.props.response.result_list != undefined)) {
            this.props.hookAppsId(this.props.response.result_list[0].app_uuid);
        }
        return (React.createElement("div", { className: "form-group" },
            React.createElement("label", { htmlFor: "appSelector" },
                React.createElement("b", null, "Application Name")),
            React.createElement("select", { className: "form-control", id: "appSelector", onChange: this.onChangeApps }, (this.props.isLoading && this.props.response.result_list != undefined) && this.props.response.result_list.map(function (item) {
                return React.createElement("option", { key: item.app_uuid, value: item.app_uuid }, item.app_name);
            }))));
    };
    return ApplicationSelector;
}(React.PureComponent));
exports.default = react_redux_1.connect(function (state) { return state.application; }, Stores.actionCreators)(ApplicationSelector);
//# sourceMappingURL=ApplicationSelector.js.map